import * as ActionTypes from './navigation.actionTypes';

const initialState = {
  open: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.OPEN: {
      return {
        ...state,
        open: true,
      };
    }
    case ActionTypes.CLOSE: {
      return {
        ...state,
        open: false,
      };
    }
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/modules/navigation/navigation.reducer.js